import { commerceFacetSetReducer as commerceFacetSet } from '../facet-set/facet-set-slice.js';
import { toggleSelectCategoryFacetValue, updateCategoryFacetNumberOfValues, } from './category-facet-actions.js';
/**
 * Loads the commerce facet set reducer and returns the available category facet action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the category facet action creators.
 *
 * @group Actions
 * @category CategoryFacet
 */
export function loadCategoryFacetSetActions(engine) {
    engine.addReducers({ commerceFacetSet });
    return {
        toggleSelectCategoryFacetValue,
        updateCategoryFacetNumberOfValues,
    };
}
